const filterData = (data: Record<string, string | undefined>) =>
	(
		Object.entries(data).filter(
			([key, value]) =>
				// get only string and key that contains REACT_APP
				typeof value === 'string' && key.toUpperCase().includes('REACT_APP')
		) as Array<[string, string]>
	).reduce<Record<string, string>>(
		(prev, [key, value]) => ({ ...prev, [key]: value }),
		{}
	);

const uKey = (key: string) => {
	const KEY = key.toUpperCase();
	const _KEY = !KEY.includes('REACT_APP') ? `REACT_APP_${KEY}` : KEY;
	return _KEY;
};

export const querystringConf = (key: string) => {
	// eslint-disable-next-line no-restricted-globals
	const url = location.href;
	const [, querystring] = url.split('?');
	const pQS = new URLSearchParams(querystring);

	const _key = uKey(key);
	const val = pQS.get(_key) ?? process.env[_key];
	if (typeof val === 'undefined') return undefined;
	else {
		try {
			return JSON.parse(val);
		} catch (e) {
			return val;
		}
	}
};
